const medias = [
  {
    name: "mail",
    icon: "fas fa-envelope",
    link: "mailto:formule@ens.etsmtl.ca",
  },
  {
    name: "youtube",
    icon: "fab fa-youtube",
    link: "https://www.youtube.com/channel/UCUD8PAN1661urrA1xzuKLmg",
  },
  {
    name: "instagram",
    icon: "fab fa-instagram",
    link: "http://instagram.com/formule_ets",
  },
  {
    name: "facebook",
    icon: "fab fa-facebook-f",
    link: "https://www.facebook.com/formuleets/",
  },
  {
    name: "linkedin",
    icon: "fab fa-linkedin",
    link: "https://ca.linkedin.com/company/etsmontreal",
  },
];

export default medias;
